import { render, staticRenderFns } from "./SetTvNames.vue?vue&type=template&id=738f035c&scoped=true"
import script from "./SetTvNames.vue?vue&type=script&lang=js"
export * from "./SetTvNames.vue?vue&type=script&lang=js"
import style0 from "./SetTvNames.vue?vue&type=style&index=0&id=738f035c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738f035c",
  null
  
)

export default component.exports